import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileListingContext } from "../../CloudFileListingContext";

interface ApproveCloudFileNotificationsDialogProps {
    onClose(): void;
    isOpen: boolean;
    itemId: string;
}

export const ApproveCloudFileNotificationsListingDialog: React.VFC<ApproveCloudFileNotificationsDialogProps> = ({
    onClose,
    isOpen,
    itemId
}: ApproveCloudFileNotificationsDialogProps) => {
    const { approveCloudFileNotifications } = useCloudFileApi();

    const { success, error } = useNotifications();

    const { approveNotifications } = useContext(CloudFileListingContext);

    const handleConfirmation = async () => {
        try {
            await approveCloudFileNotifications({ cloudFileId: itemId });

            approveNotifications(itemId);

            success("Buzz notifications approved");
        } catch {
            error("Buzz notifications approve failed");
        }

        onClose();
    };

    return (
        <ConfirmDialog
            title="Approve buzz notifications"
            text="Are you sure you want to approve buzz notifications? Once approved, they cannot be turned off."
            hidden={!isOpen}
            confirm={{ onClick: handleConfirmation }}
            cancel={{ onClick: onClose }}
        />
    );
};
